import { render, staticRenderFns } from "./AudienceOverview.vue?vue&type=template&id=4b1e5a75&scoped=true"
import script from "./AudienceOverview.vue?vue&type=script&lang=js"
export * from "./AudienceOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1e5a75",
  null
  
)

export default component.exports